import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link as RouterLink } from "react-router-dom";

import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

import useApp from 'app/context/useApp';
import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    form: {
        maxWidth: '380px'
    },
    section: {
        marginTop: theme.spacing(3),
    },
    sectionCenter: {
        marginTop: theme.spacing(3),
        textAlign: 'center'
    }
}));

export default function EmailForm(props) {

    const [ username, setUsername ] = useState("");

    const [ error, setError ] = useState(null);
    const [ success, setSuccess ] = useState(null);

    const { app } = useApp();
    const { onLoading, loading } = props;
    const classes = useStyles();
    const api = useApi();

    const handleUsername = e => {

        const value = e.target.value;

        if (error) setError(null);

        setUsername(value);
    };

    const postUsername = e => {

        e.preventDefault();

        onLoading(true);
        setError(null);
        setSuccess(null);

        api.post('/auth/reset/email', {username: username}).then(res => {

            setSuccess('A password reset email has been sent to your email address.')

        }).catch(error => {

            if (error?.response?.data?.errors) {
                setError(error.response.data.errors['username'][0])
            }

        }).then(() => onLoading(false));
    }

    const support_email = app.club ? app.club.support_email : process.env.MIX_SUPPORT_EMAIL;

    return (
        <div className={classes.form}>
            <form noValidate>
                <Typography variant="subtitle2" component="h2">
                    Enter your registered email / username below to send the password reset link.
                </Typography>
                <div className={classes.section}>
                    <TextField
                        id="input-email-username"
                        label="Email / Username"
                        name="email"
                        fullWidth
                        autoFocus
                        color="secondary"
                        variant="outlined"
                        error={error ? true : false}
                        value={username}
                        onChange={handleUsername}
                    />
                </div>
                <div className={classes.sectionCenter}>
                    <Button variant="contained" color="secondary" fullWidth onClick={postUsername} disabled={loading}>
                        Send Reset Email
                    </Button>
                </div>
                {error &&
                    <Alert className={classes.section} severity="error">{error}</Alert>
                }
                {success &&
                    <Alert className={classes.section} severity="success">{success}</Alert>
                }
                <Typography
                    variant="subtitle2"
                    component="h5"
                    color="textSecondary"
                    className={classes.section}
                    >
                    If you do not receive an email, please contact support for further assistance at <Link color="secondary" href={"mailto:" + support_email} target="_blank">{support_email}</Link>.
                </Typography>
                <Button
                    className={classes.section}
                    variant="outlined"
                    color="secondary"
                    disabled={loading}
                    component={RouterLink}
                    fullWidth
                    to="/login"
                    >
                    Back to Login
                </Button>
            </form>
        </div>
    );
}
